.root {
  --agent-panel-width: 560px;

  inset: 0;
  position: fixed;
  z-index: 60;
}

.backdrop {
  background: rgba(0, 0, 0, 0.25);
  border: none;
  cursor: default;
  inset: 0;
  position: absolute;
}

.panel {
  // Spring-y cubic-bezier feels snappier than `ease`, especially over a
  // long horizontal travel.
  animation: slide-in 0.26s cubic-bezier(0.2, 0.85, 0.3, 1);
  background: var(--color-background);
  border-left: 1px solid var(--color-border);
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: var(--agent-panel-width);
  z-index: 1;
}

// Backdrop fades alongside the panel — without this the dim layer
// snaps off at unmount which feels janky.
.backdrop {
  animation: backdrop-in 0.18s ease-out;
}

// Closing transition: the panel slides out, the backdrop fades. Both
// ride the same duration as `AGENT_PANEL_CLOSE_DURATION_MS` in the
// store so the animation finishes precisely when the panel unmounts.
.root-mode-closing {
  pointer-events: none;
}

.root-mode-closing .panel {
  animation: slide-out 0.22s cubic-bezier(0.4, 0, 0.6, 1) forwards;
}

.root-mode-closing .backdrop {
  animation: backdrop-out 0.22s ease-in forwards;
}

.search {
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 8px;
  padding: 12px 20px;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 20px 16px;
}

// Dynamic Agent Loop Engine surface (#276).
.mode-toggle {
  display: flex;
  justify-content: flex-end;
}

.dynamic-hint {
  color: var(--color-muted-foreground, #71717a);
}

.dynamic-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.undo-last {
  display: flex;
  justify-content: flex-start;
}

.root-mode-loading .panel {
  border-left-color: var(--color-primary);
}

.root-mode-recording .panel {
  border-left-color: var(--color-destructive);
}

.root-mode-transcribing .panel {
  border-left-color: var(--color-primary);
}

.root-mode-drag .panel {
  pointer-events: none;
}

.listening-subtitle {
  align-items: center;
  color: var(--color-destructive);
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  gap: 6px;
}

.listening-dot {
  animation: listening-pulse 1.2s ease-in-out infinite;
  background: var(--color-destructive);
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  width: 8px;
}

.voice-banner {
  align-items: flex-start;
  background: var(--color-accent);
  border: 1px solid var(--color-accent-border);
  border-radius: 10px;
  color: var(--color-accent-foreground);
  display: flex;
  gap: 8px;
  padding: 8px 12px;
}

@keyframes listening-pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }
}

@keyframes slide-in {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
}

@keyframes backdrop-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes backdrop-out {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .root {
    --agent-panel-width: 100%;
  }

  .panel {
    border-left: none;
  }
}

// Phone-sized breakpoint (≤ 480 px) matches design frame `igs09`. Tighten
// the body padding so generator forms (email body, manual brief, LLM-
// unavailable card) feel native on phones — every step uses `.body`-style
// padding via the parent panel.
@media (max-width: 480px) {
  .body {
    padding: 12px 16px;
  }

  .search {
    padding: 10px 16px;
  }
}
